import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./routes/Home";
import ProjectPage from "./routes/projects/ProjectPage";
import Navbar from "./components/navbar";

import { LocomotiveScrollProvider } from "react-locomotive-scroll";
import { useRef, useEffect, useLayoutEffect } from "react";
import "locomotive-scroll/dist/locomotive-scroll.css";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { PreloadProvider } from "./components/helpers/preloadMedia";

function App() {
  const containerRef = useRef(null);

  const options = {
    smooth: true,
  };

  const ScrollManager = () => {
    const { scroll } = useLocomotiveScroll();
    const location = useLocation();
    const savedHomeY = useRef(0);

    // Reposition synchronously before the new route paints, so there is no
    // visible jump; recalculate page height afterwards once content settled.
    useLayoutEffect(() => {
      if (!scroll) return;
      const isHome = location.pathname === "/";
      if (!isHome) {
        // Leaving home: remember the position, open detail pages at the top.
        savedHomeY.current = scroll.scroll?.instance?.scroll?.y || 0;
      }
      scroll.scrollTo(isHome ? savedHomeY.current : 0, {
        duration: 0,
        disableLerp: true,
      });
      const timer = setTimeout(() => scroll.update(), 100);
      return () => clearTimeout(timer);
    }, [location.pathname, scroll]);

    return null;
  };

  return (
    <>
      <PreloadProvider>
        <LocomotiveScrollProvider options={options} containerRef={containerRef}>
          <ScrollManager />
          <main data-scroll-container ref={containerRef}>
            <Navbar />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects/:id" element={<ProjectPage />} />
            </Routes>
          </main>
        </LocomotiveScrollProvider>
      </PreloadProvider>
    </>
  );
}

export default App;
